import {useEffect, useRef} from 'react';

const useBeforeUnload = (isDirty: boolean) => {
    const canClose = useRef<boolean>(false);

    useEffect(() => {
        const onUnload = (event: BeforeUnloadEvent) => {
            if (!canClose.current) {
                event.preventDefault();
                // Required for Google Chrome

                event.returnValue = null;
            }
        };

        if (isDirty) {
            window.addEventListener('beforeunload', onUnload);
        }

        return () => window.removeEventListener('beforeunload', onUnload);
    }, [isDirty]);

    const allowPageChange = () => {
        canClose.current = true;
    };

    const disallowPageChange = () => {
        canClose.current = false;
    };

    return {allowPageChange, disallowPageChange};
};

export default useBeforeUnload;
